<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { fetchApiHealth } from '@/lib/health';

type ReadinessState = 'checking' | 'ready' | 'unavailable';

const readiness = ref<ReadinessState>('checking');

onMounted(async () => {
  try {
    await fetchApiHealth();
    readiness.value = 'ready';
  } catch {
    readiness.value = 'unavailable';
  }
});
</script>

<template>
  <main class="shell">
    <header class="masthead">
      <div class="brand-mark" aria-hidden="true">郎</div>
      <div>
        <p class="eyebrow">HSL Expense Management System</p>
        <h1>郎报通</h1>
        <p class="tagline">费用在线申报，审批全程贯通</p>
      </div>
    </header>

    <section class="hero" aria-labelledby="foundation-title">
      <div>
        <p class="phase">P3 · 在线审批</p>
        <h2 id="foundation-title">申请与审批全程贯通</h2>
        <p class="summary">
          四类申请统一在线提交，系统冻结快照并匹配审批流程；审批人通过待办工作台完成处理和历史追溯。
        </p>
        <RouterLink class="primary-link" to="/login">登录郎报通</RouterLink>
      </div>
      <div class="status-card" aria-live="polite">
        <span class="status-dot" :class="`status-dot--${readiness}`" />
        <div>
          <strong>API 就绪状态</strong>
          <p v-if="readiness === 'checking'">正在检查基础服务…</p>
          <p v-else-if="readiness === 'ready'">MySQL 连接正常</p>
          <p v-else>服务尚未启动或依赖不可用</p>
        </div>
      </div>
    </section>

    <section class="capabilities" aria-label="P3 核心能力">
      <article>
        <span>01</span>
        <h3>安全提交</h3>
        <p>提交时冻结组织、申请人、收款方和流程快照，并使用幂等与版本锁避免重复操作。</p>
      </article>
      <article>
        <span>02</span>
        <h3>规则化审批</h3>
        <p>按组织、单据类型、费用类别和金额确定流程，支持任一通过与全部会签。</p>
      </article>
      <article>
        <span>03</span>
        <h3>完整留痕</h3>
        <p>通过、退回、驳回、撤回和转交均保留动作、意见、版本与不可变审计证据。</p>
      </article>
    </section>
  </main>
</template>
